import React from 'react';
import { useDateHelper } from 'nekst-api';
import { InformationMessage } from 'features/nekst-widgets';
import { LockInBannerToggleWrapper } from 'feature-toggle';
import { useBillingContext } from './BillingPageContext';

function LockInStatusContent() {
  const billingData = useBillingContext().getData();
  const teamBilling = billingData.teamBilling;
  const dateHelper = useDateHelper();

  if (!teamBilling.lockInExpiresAt || teamBilling.lockInExpiresAt <= new Date()) {
    return null;
  } else {
    return (
      <InformationMessage>
        <strong>Your rate is locked
          {teamBilling.lockInOffer && <> at ${teamBilling.lockInOffer.lockInMonthlyRate.toLocaleString()}/mo</>}
          {' '}until {dateHelper.toString(teamBilling.lockInExpiresAt)}.</strong>
        {teamBilling.lockInOffer && (
          <>
            {' '}
            After your lock-in expires, your plan will transition to ${teamBilling.lockInOffer.postLockInMonthlyPrice.toLocaleString()}/month.
          </>
        )}
      </InformationMessage>
    );
  }
}

export default function LockInStatusDisplay() {
  return (
    <LockInBannerToggleWrapper>
      <LockInStatusContent />
    </LockInBannerToggleWrapper>
  );
}
